<div>
  <h2>Signing you in...</h2>
  <p>Please wait while we complete the authentication process.</p>
</div>
